// @flow
import PassagesPage from './PassagesPage';

export default PassagesPage;
